import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbarTitle: {
    textDecoration: 'none',
    color: 'inherit',
    padding: theme.spacing(2, 2)
  },
  googleSignIn: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  circularProgress: {
    margin: 'theme.spacing(0, 0, 0, 2)'
  }
}));
